"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mui_1 = require("tss-react/mui");
const classnames_1 = __importDefault(require("classnames"));
const Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const BarChartRounded_1 = __importDefault(require("@mui/icons-material/BarChartRounded"));
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const QIconButton_1 = __importDefault(require("components/QIconButton"));
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const AmountField_1 = __importDefault(require("components/QuickenControls/AmountField"));
const CategoryReviewPopupCard_1 = __importDefault(require("components/CategoryReviewPopupCard"));
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const SuggestedBudgetItem = ({ item = { id: 'header' }, currency, accountIds, selected, onChange, header, classesExternal }) => {
    const [catReviewAnchorEl, setCatReviewAnchorEl] = (0, react_1.useState)(null);
    const [showIcons, setShowIcons] = (0, react_1.useState)(false);
    const { classes } = useStyles();
    const constructName = () => {
        if (header) {
            return ['Category', ''];
        }
        let str = chart_of_accounts_1.chartOfAccountsSelectors.getCoaStringSelector(undefined, item.coa);
        let parentStr = '';
        const catParts = str.split(':');
        if (catParts && catParts.length > 1) {
            parentStr = `(${catParts[catParts.length - 2]})`;
            str = catParts[catParts.length - 1];
        }
        return [str, parentStr];
    };
    const nameArray = constructName();
    return (<div className={(0, classnames_1.default)(classesExternal === null || classesExternal === void 0 ? void 0 : classesExternal.categoryRow, classes.categoryRow)} onMouseEnter={() => setShowIcons(true)} onMouseLeave={() => setShowIcons(false)}>
      <Checkbox_1.default checked={selected} id={`suggested-categories-checkbox-${nameArray[0]}${nameArray[1]}`} onChange={header ? onChange : () => onChange(item.key || item.coa.id)}/>
      <div className={classes.categoryNameWrapper}>
        <Typography_1.default key={`editBudgetCats:str1 ${item.id}`} variant={header ? 'subtitle1' : 'body2'} className={header ? classes.headerText : classes.categoryName}>
          {nameArray[0]}
        </Typography_1.default>
        <Typography_1.default key={`editBudgetCats:str2 ${item.id}`} variant="body2" className={classes.categoryNameParent}>
          {nameArray[1]}
        </Typography_1.default>
      </div>
      <div className={classes.categoryAmount}>
        {header &&
            <Typography_1.default variant={header ? 'subtitle1' : 'body2'} className={header ? classes.headerText : classes.categoryName}>
            Amount
          </Typography_1.default>}
        {!header &&
            <QTip_1.default title="You can edit the default amount after you add it to the budget">
            <AmountField_1.default id={`budgetAmt:${nameArray[0]}`} value={Math.abs(item.monthlyAverage)} currencySymbol={currency} currencyGap disableUnderline className={header ? null : classes.amountInputStyle} omitCents/>
          </QTip_1.default>}
      </div>
      <div className={(0, classnames_1.default)(classes.iconHolder, showIcons ? '' : classes.hide)}>
        {!header &&
            <>
            <QTip_1.default title="Category Details Card...">
              <QIconButton_1.default aria-label="Show Budget Item Info" onClick={(e) => setCatReviewAnchorEl(e.currentTarget)} id={`row-${item.id}-delete-item`} size="small">
                <BarChartRounded_1.default className={classes.barChartIcon}/>
              </QIconButton_1.default>
            </QTip_1.default>
            <CategoryReviewPopupCard_1.default anchorEl={catReviewAnchorEl} open onClose={() => setCatReviewAnchorEl(null)} coaIds={[item.coa.id]} classes={{
                    root: classes.categoryReviewCardRoot,
                }} currency={currency} accountIds={accountIds}/>
          </>}
      </div>
    </div>);
};
exports.default = SuggestedBudgetItem;
